import { type ConsentGovernanceVersion } from "src/api/client-api/consent/useGetConsentGovernanceAdmin";

export type ConsentVersionStatus = "draft" | "published" | "archived";

export const getConsentVersionStatus = (version: ConsentGovernanceVersion): ConsentVersionStatus => {
    if (version.status) {
        return version.status;
    }

    if (version.archivedAt) {
        return "archived";
    }

    return version.published ? "published" : "draft";
};

export const isConsentVersionArchived = (version: ConsentGovernanceVersion | undefined): boolean =>
    version !== undefined && getConsentVersionStatus(version) === "archived";
